import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import BackButton from '../COMPONENTS/BackButton';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { GAME_PAGE } from '../../HOME/const';
import { goToPage } from '../../HOME/REDUX/actions';
import { selectSize } from '../REDUX/actions';
import { windowSize, delay } from '../../HOME/utils';
import { Background } from '../COMPONENTS/Background';
import SizeIcon from '../COMPONENTS/SizeIcon';
import _ from 'lodash';
import * as f from '../logic';

class SizePage extends Component {
  handleSize = size => e => {
    delay(() => {
      this.props.selectSize(size);
      this.props.goToPage(GAME_PAGE);
    }, 200);
  };

  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  sizeName = size => {
    switch (size) {
      case 3:
        return 'X-SMALL';
      case 4:
        return 'SMALL';
      case 5:
        return 'MEDIUM';
      case 6:
        return 'LARGE';
      case 7:
        return 'X-LARGE';
      default:
        break;
    }
  };

  render() {
    const { x, y } = windowSize();
    const cls = f.selectorClass(x, y);
    const color = 'rgb(216, 153, 164)';

    return (
      <div className="page-root">
        <div className={cls} style={{ backgroundImage: Background }}>
          {_.map([3, 4, 5, 6, 7], (size, i) => {
            const flow = x < y ? 'column' : 'row';
            const label = this.sizeName(size);
            return (
              <div key={size} className="option triangula-option" style={{ gridAutoFlow: flow }} onClick={this.handleSize(size)}>
                <span style={{ gridArea: '1/1', transform: 'translate(0.08em, 0.08em)' }}>
                  <SizeIcon size={size} width="50px" color="black" />
                </span>
                <span style={{ gridArea: '1/1', zIndex: 1 }}>
                  <SizeIcon size={size} width="50px" />
                </span>
                <div style={{ display: 'grid', fontSize: '16px', fontWeight: 'bold', margin: '5px 10px' }}>
                  <span style={{ color, gridArea: '1/1', textShadow: '0.08em 0.08em black' }}>{label}</span>
                </div>
              </div>
            );
          })}
        </div>
        <BackButton />
        <HomeButton />
      </div>
    );
  }
}

function mapStateToProps({ mt, common }) {
  return { ...mt, ...common };
}

export default connect(
  mapStateToProps,
  { selectSize, goToPage }
)(SizePage);
